import React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter,  Routes, Route } from 'react-router-dom';

import { GlobalStyles } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import muiTheme from 'theme/MuiTheme';
import globalStyles from 'theme/GlobalStyle';

import "@fontsource/roboto"


import HomePage from 'pages/HomePage';


//const inputGlobalStyles = <GlobalStyles styles={globalStyles}/>

//<React.StrictMode>


ReactDOM.render((
    <ThemeProvider theme={muiTheme}>
    <GlobalStyles styles={globalStyles}/>
    <BrowserRouter>
    <Routes>
        <Route path='/' element={<HomePage />}/>
    </Routes>
    </BrowserRouter>
    </ThemeProvider>
    ),
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
